/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video from 'components/Video/Video';
import './SpannedVideo.scss';

/**
 * This is the SpannedVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function SpannedVideo(props) {
  return (
    <div className="block spanned-video">
      <Video {...props} scrollTo={{ alignTop: false, offset: 0 }} />
    </div>
  );
}

export default SpannedVideo;
